export default function notificationHelper($translate, NotificationService) {
  return {
    showError: showError,
  };

  function showError(res, defaultMessage) {
    var output,
      errorMessages = [];
    if (res && res.data && res.data.errors) {
      if (angular.isArray(res.data.errors)) {
        res.data.errors.forEach(function(error) {
          if (error.message) {
            errorMessages.push($translate.instant(error.message));
          }
        });
      } else if (res.data.errors.message) {
        errorMessages.push($translate.instant(res.data.errors.message));
      }
    }
    output = errorMessages.length ? errorMessages.join('; ') : defaultMessage;
    NotificationService.error(output);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/notification.helper.js